import { render, staticRenderFns } from "./CheckboxBlock.vue?vue&type=template&id=d74c8c1a&"
import script from "./CheckboxBlock.vue?vue&type=script&lang=js&"
export * from "./CheckboxBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports